interface IUseCustomization {
  apiKey?: string;
}

const customApiKeys: { [apiKey: string]: string } = {
  fPFIb7J8BuDxXwJf3L8w: 'intel',
  '9zCcaFNoeSQ1rQfwOwdB': 'ezy-math-tutoring',
  GUlUcGynVDqvpuDAmrdd: 'momentum',
  pxvwrhd4Tmm97PiW85yq: 'aspen-medical',
  MBHYJeoKJkETKBSYrX2f: 'cluey-learning',
  AASWTnNO3Snzotx8Axhp: 'manara',
};

export const useCustomization = ({ apiKey = '' }:IUseCustomization) => {
  if (apiKey && customApiKeys[apiKey]) {
    return document.documentElement.setAttribute('data-custom', customApiKeys[apiKey]);
  }
  return false;
};
